export const APIConstants = {
  CONFIG: {
    SESSION_INIT_URL: 'SESSION_INIT_URL',
    HEARTBEAT_URL: 'HEARTBEAT_URL',
  },
};

export enum CREATE_SESSION_ACTION_TYPE {
  CREATE = 'create',
  DROP = 'drop',
}
